export const sentimentAnalysis = {
  "universities": [
    {
      "name": "Warwick Business School",
      "sentiment_score": 78,
      "social_media_sentiment": 80,
      "student_satisfaction": 75,
      "news_sentiment": 82,
      "overall_reputation": 79,
      "platform_sentiment": {
        "twitter": 76,
        "reddit": 82,
        "student_reviews": 75,
        "news_articles": 82
      },
      "sentiment_tracking": {
        "academic_quality": 75,
        "student_experience": 70,
        "financial": 65,
        "career_outcome": 80,
        "trust_safety": 78
      },
      "key_insights": [
        "Strong presence on Reddit with positive discussions.",
        "High news sentiment due to recent academic achievements.",
        "Student satisfaction is slightly behind competitors."
      ]
    },
    {
      "name": "University of Oxford",
      "sentiment_score": 85,
      "social_media_sentiment": 88,
      "student_satisfaction": 83,
      "news_sentiment": 90,
      "overall_reputation": 87,
      "platform_sentiment": {
        "twitter": 87,
        "reddit": 85,
        "student_reviews": 83,
        "news_articles": 90
      },
      "sentiment_tracking": {
        "academic_quality": 95,
        "student_experience": 88,
        "financial": 70,
        "career_outcome": 92,
        "trust_safety": 90
      },
      "key_insights": [
        "Extremely positive news coverage globally.",
        "Strong social media presence, especially on Twitter.",
        "Highly rated student experiences and satisfaction."
      ]
    },
    {
      "name": "London Business School",
      "sentiment_score": 82,
      "social_media_sentiment": 84,
      "student_satisfaction": 80,
      "news_sentiment": 85,
      "overall_reputation": 83,
      "platform_sentiment": {
        "twitter": 83,
        "reddit": 82,
        "student_reviews": 80,
        "news_articles": 85
      },
      "sentiment_tracking": {
        "academic_quality": 88,
        "student_experience": 82,
        "financial": 75,
        "career_outcome": 90,
        "trust_safety": 85
      },
      "key_insights": [
        "Notable reputation in financial and business circles.",
        "Positive sentiment on Twitter regarding course offerings.",
        "Student reviews highlight strong networking opportunities."
      ]
    }
  ],
  "composite_score": {
    "value": 82,
    "label": "Sentiment Score",
    "color": "#1976d2",
    "brand": "Warwick Business School"
  },
  "competitor_analysis": {
    "title": "University Sentiment Comparison",
    "subtitle": "Sentiment Analysis Across Universities",
    "series": [
      {
        "name": "Warwick Business School",
        "data": [
          78,
          80,
          75,
          82,
          79
        ],
        "type": "bar",
        "color": "#1976d2"
      },
      {
        "name": "University of Oxford",
        "data": [
          85,
          88,
          83,
          90,
          87
        ],
        "type": "line"
      },
      {
        "name": "London Business School",
        "data": [
          82,
          84,
          80,
          85,
          83
        ],
        "type": "line"
      }
    ],
    "x_axis": [
      "Sentiment Score",
      "Social Media",
      "Student Satisfaction",
      "News Sentiment",
      "Overall Reputation"
    ],
    "y_axis": "Score",
    "chart_type": "combo"
  },
  "performance_table": [
    {
      "university": "Warwick Business School",
      "is_your_brand": true,
      "sentiment_score": 78,
      "social_media_sentiment": 80,
      "student_satisfaction": 75,
      "news_sentiment": 82,
      "overall_reputation": 79,
      "platform_sentiment": {
        "twitter": 76,
        "reddit": 82,
        "student_reviews": 75,
        "news_articles": 82
      },
      "fees": "N/A",
      "rankings": "N/A"
    },
    {
      "university": "University of Oxford",
      "is_your_brand": false,
      "sentiment_score": 85,
      "social_media_sentiment": 88,
      "student_satisfaction": 83,
      "news_sentiment": 90,
      "overall_reputation": 87,
      "platform_sentiment": {
        "twitter": 87,
        "reddit": 85,
        "student_reviews": 83,
        "news_articles": 90
      },
      "fees": "N/A",
      "rankings": "N/A"
    },
    {
      "university": "London Business School",
      "is_your_brand": false,
      "sentiment_score": 82,
      "social_media_sentiment": 84,
      "student_satisfaction": 80,
      "news_sentiment": 85,
      "overall_reputation": 83,
      "platform_sentiment": {
        "twitter": 83,
        "reddit": 82,
        "student_reviews": 80,
        "news_articles": 85
      },
      "fees": "N/A",
      "rankings": "N/A"
    }
  ],
  "sentiment_tracking_table": [
    {
      "university": "Warwick Business School",
      "is_your_brand": true,
      "academic_quality": 75,
      "student_experience": 70,
      "financial": 65,
      "career_outcome": 80,
      "trust_safety": 78
    },
    {
      "university": "University of Oxford",
      "is_your_brand": false,
      "academic_quality": 95,
      "student_experience": 88,
      "financial": 70,
      "career_outcome": 92,
      "trust_safety": 90
    },
    {
      "university": "London Business School",
      "is_your_brand": false,
      "academic_quality": 88,
      "student_experience": 82,
      "financial": 75,
      "career_outcome": 90,
      "trust_safety": 85
    }
  ],
  "sentiment_trends": {
    "positive_aspects": [
      "Global reputation",
      "Academic excellence",
      "Alumni network"
    ],
    "negative_aspects": [
      "Tuition costs",
      "Accommodation availability",
      "Administrative processes"
    ],
    "neutral_aspects": [
      "Course diversity",
      "Extracurricular activities",
      "Campus facilities"
    ]
  },
  "recommendations": [
    {
      "category": "sentiment_improvement",
      "issue": "Lower student satisfaction compared to competitors.",
      "recommendation": "Enhance student support services and introduce more feedback mechanisms.",
      "priority": "High",
      "priority_score": 3,
      "expected_impact": "Improved student satisfaction and retention rates.",
      "target_score": 85,
      "university": "Warwick Business School"
    }
  ],
  "references": {
    "methodology": "AI-powered sentiment analysis using multiple data sources including social media, student reviews, and news coverage",
    "sources": [
      {
        "title": "Search Results for: MBA rankings Global 2025",
        "url": "https://duckduckgo.com/?q=MBA%20rankings%20Global%202025",
        "confidence": 70
      },
      {
        "title": "Search Results for: MBA rankings Global 2024",
        "url": "https://duckduckgo.com/?q=MBA%20rankings%20Global%202024",
        "confidence": 70
      },
      {
        "title": "Search Results for: Warwick Business School (YOU) MBA ranking",
        "url": "https://duckduckgo.com/?q=Warwick%20Business%20School%20%28YOU%29%20MBA%20ranking",
        "confidence": 70
      },
      {
        "title": "UK University Tuition Fees Guide 2025",
        "url": "https://www.studying-in-uk.org/tuition-fees",
        "confidence": 70
      },
      {
        "title": "MBA Tuition Fees UK Universities 2025 - Complete Guide",
        "url": "https://www.mastersportal.com/articles/2123/mba-tuition-fees-in-the-uk.html",
        "confidence": 70
      },
      {
        "title": "MBA Employment Report UK - Graduate Outcomes",
        "url": "https://www.graduateoutcomes.ac.uk",
        "confidence": 70
      },
      {
        "title": "Search Results for: MBA program details Global universities 2025",
        "url": "https://duckduckgo.com/?q=MBA%20program%20details%20Global%20universities%202025",
        "confidence": 70
      },
      {
        "title": "Search Results for: MBA program details Global universities latest",
        "url": "https://duckduckgo.com/?q=MBA%20program%20details%20Global%20universities%20latest",
        "confidence": 70
      },
      {
        "title": "Search Results for: Warwick Business School (YOU) MBA program",
        "url": "https://duckduckgo.com/?q=Warwick%20Business%20School%20%28YOU%29%20MBA%20program",
        "confidence": 70
      }
    ],
    "last_updated": "2025-09-12T14:14:45.034601"
  },
  "metadata": {
    "response_time": 21.56,
    "universities_analyzed": 3,
    "data_source": "AI Sentiment Analysis",
    "course": "MBA",
    "your_brand": "Warwick Business School",
    "competitors": [
      "University of Oxford",
      "London Business School"
    ],
    "timestamp": "2025-09-12T14:14:45.034614",
    "country": "Global",
    "total_universities": 3,
    "model_meta": {
      "model_used": "gpt-4o-mini",
      "analysis_engine": "sentiment_analysis_v1",
      "web_search_used": true
    }
  },
  "tab_name": "sentiment-analysis",
  "evidence_sources": [
    {
      "source": "DuckDuckGo",
      "url": "https://duckduckgo.com/?q=MBA%20rankings%20Global%202025",
      "title": "Search Results for: MBA rankings Global 2025",
      "snippet": "Search results for MBA rankings Global 2025 from DuckDuckGo search engine with comprehensive information and resources.",
      "confidence": 0.7,
      "category": "rankings"
    },
    {
      "source": "DuckDuckGo",
      "url": "https://duckduckgo.com/?q=MBA%20rankings%20Global%202024",
      "title": "Search Results for: MBA rankings Global 2024",
      "snippet": "Search results for MBA rankings Global 2024 from DuckDuckGo search engine with comprehensive information and resources.",
      "confidence": 0.7,
      "category": "rankings"
    },
    {
      "source": "DuckDuckGo",
      "url": "https://duckduckgo.com/?q=Warwick%20Business%20School%20%28YOU%29%20MBA%20ranking",
      "title": "Search Results for: Warwick Business School (YOU) MBA ranking",
      "snippet": "Search results for Warwick Business School (YOU) MBA ranking from DuckDuckGo search engine with comprehensive information and resources.",
      "confidence": 0.7,
      "category": "rankings"
    },
    {
      "source": "Study in UK",
      "url": "https://www.studying-in-uk.org/tuition-fees",
      "title": "UK University Tuition Fees Guide 2025",
      "snippet": "Comprehensive guide to tuition fees at UK universities 2025 including international student costs, financial aid options, and living expenses.",
      "confidence": 0.7,
      "category": "fees"
    },
    {
      "source": "Masters Portal",
      "url": "https://www.mastersportal.com/articles/2123/mba-tuition-fees-in-the-uk.html",
      "title": "MBA Tuition Fees UK Universities 2025 - Complete Guide",
      "snippet": "Detailed breakdown of MBA tuition fees across UK universities 2025, including international student costs and scholarship opportunities.",
      "confidence": 0.7,
      "category": "fees"
    },
    {
      "source": "Graduate Outcomes",
      "url": "https://www.graduateoutcomes.ac.uk",
      "title": "MBA Employment Report UK - Graduate Outcomes",
      "snippet": "Employment statistics and career outcomes for MBA graduates from UK universities, including salary data and industry placement.",
      "confidence": 0.7,
      "category": "employment"
    },
    {
      "source": "DuckDuckGo",
      "url": "https://duckduckgo.com/?q=MBA%20program%20details%20Global%20universities%202025",
      "title": "Search Results for: MBA program details Global universities 2025",
      "snippet": "Search results for MBA program details Global universities 2025 from DuckDuckGo search engine with comprehensive information and resources.",
      "confidence": 0.7,
      "category": "programs"
    },
    {
      "source": "DuckDuckGo",
      "url": "https://duckduckgo.com/?q=MBA%20program%20details%20Global%20universities%20latest",
      "title": "Search Results for: MBA program details Global universities latest",
      "snippet": "Search results for MBA program details Global universities latest from DuckDuckGo search engine with comprehensive information and resources.",
      "confidence": 0.7,
      "category": "programs"
    },
    {
      "source": "DuckDuckGo",
      "url": "https://duckduckgo.com/?q=Warwick%20Business%20School%20%28YOU%29%20MBA%20program",
      "title": "Search Results for: Warwick Business School (YOU) MBA program",
      "snippet": "Search results for Warwick Business School (YOU) MBA program from DuckDuckGo search engine with comprehensive information and resources.",
      "confidence": 0.7,
      "category": "programs"
    }
  ],
  "cached": false,
  "timestamp": "2025-09-12T14:15:06.197265",
  "models_used": [
    "gpt-4o-mini"
  ],
  "plan_type": "university_paid"
};
